/*@ngInject*/
const BulkReassignRepository = function (baseRepository) {
    angular.extend(this, baseRepository);

    this.reassign = function (params, assignee) {
        let url = '/rest/SubmissionTask/bulkUpdate',
            config = {
                params: params
            },
            body = {};

        if(assignee.group === 'User Groups') {
            body.assignedToId = null;
            body.assignedToFullName = null;
            body.assignedToGroupId = assignee.id;
            body.assignedToGroupName = assignee.name;
        } else {
            body.assignedToId = assignee.id;
            body.assignedToFullName = assignee.name;
            body.assignedToGroupId = null;
            body.assignedToGroupName = null;
        }
        return this.post(url, body, config);
    };
};

angular.module('umLanding')
    .service('bulkReassignRepository', BulkReassignRepository);
